module.exports = __webpack_public_path__ + "img/ball-4.89a2dbcc.png";